(function(){
  function init(root){
    root=root||document;
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}})},{threshold:.12});
    root.querySelectorAll('.bb-reveal:not(.is-in)').forEach(function(el){io.observe(el)});
    root.querySelectorAll('[data-bb-words]').forEach(function(p){
      if(p.dataset.split)return;p.dataset.split=1;
      p.innerHTML=p.textContent.trim().split(/\s+/).map(function(w){return '<span class="w">'+w+'</span> '}).join('');
    });
  }
  window.__bbWords=function(){scrollWords()};
  function scrollWords(){
    var vh=window.innerHeight;
    document.querySelectorAll('[data-bb-words]').forEach(function(p){
      var r=p.getBoundingClientRect(),ws=p.querySelectorAll('.w');if(!ws.length)return;
      var prog=Math.min(1,Math.max(0,(vh*.85-r.top)/(r.height+vh*.35)));
      var n=Math.round(prog*ws.length);
      ws.forEach(function(w,i){w.classList.toggle('on',i<n)});
    });
  }
  function hdr(){
    var h=document.querySelector('header-component,.header');
    if(h)document.documentElement.style.setProperty('--bb-header-h',h.offsetHeight+'px');
  }
  document.addEventListener('DOMContentLoaded',function(){init();hdr();scrollWords()});
  document.addEventListener('shopify:section:load',function(e){init(e.target);scrollWords()});
  
  window.addEventListener('resize',function(){hdr();scrollWords()});
})();

/* hero: cursor trail + arch parallax; arches: pinned horizontal scroll */
(function(){
  var imgs=[],last={x:0,y:0},idx=0,lastT=0;
  function setup(){
    document.querySelectorAll('[data-bb-hero]').forEach(function(h){
      if(h.dataset.bound)return;h.dataset.bound=1;
      imgs=[].map.call(h.querySelectorAll('.bb-trail-src span'),function(s){return s.dataset.src});
      var arch=h.querySelector('[data-bb-arch]');
      h.addEventListener('mousemove',function(e){
        var r=h.getBoundingClientRect(),x=e.clientX-r.left,y=e.clientY-r.top;
        if(arch){arch.style.setProperty('--mx',((x/r.width-.5)*-26)+'px');arch.style.setProperty('--my',((y/r.height-.5)*-18)+'px')}
        var dx=x-last.x,dy=y-last.y,now=performance.now();
        if(imgs.length&&dx*dx+dy*dy>150*150&&now-lastT>90){
          last={x:x,y:y};lastT=now;
          var d=document.createElement('div');d.className='bb-trail';
          d.style.left=x+'px';d.style.top=y+'px';d.style.setProperty('--r',((Math.random()-.5)*16)+'deg');
          d.innerHTML='<img alt="" src="'+imgs[idx++%imgs.length]+'">';
          h.appendChild(d);setTimeout(function(){d.remove()},1500);
        }
      });
    });
  }
  window.__bbArches=function(){arches()};
  function arches(){
    document.querySelectorAll('[data-bb-arches]').forEach(function(s){
      var track=s.querySelector('[data-track]'),bar=s.querySelector('.bb-arches__bar i');
      if(window.innerWidth<900){track.style.transform='';return}
      var r=s.getBoundingClientRect(),total=s.offsetHeight-window.innerHeight;
      var p=Math.min(1,Math.max(0,-r.top/total));
      var dist=track.scrollWidth-window.innerWidth;
      track.style.transform='translate3d('+(-p*dist)+'px,0,0)';
      if(bar)bar.style.transform='scaleX('+p+')';
    });
  }
  document.addEventListener('DOMContentLoaded',setup);
  document.addEventListener('shopify:section:load',setup);
  
  window.addEventListener('resize',arches);
  document.addEventListener('DOMContentLoaded',arches);
})();

/* Horizon scrolls inside .page-wrapper, not window: listen with capture so any scroll container triggers updates (throttled to one frame) */
(function(){
  var queued=false;
  function run(){queued=false;try{window.__bbWords&&window.__bbWords();window.__bbArches&&window.__bbArches()}catch(e){}}
  function queue(){if(!queued){queued=true;requestAnimationFrame(run)}}
  document.addEventListener('scroll',queue,{passive:true,capture:true});
  window.addEventListener('resize',queue);
  document.addEventListener('DOMContentLoaded',queue);
  setInterval(function(){if(!document.hidden)queue()},400);
})();

/* carousel: scroll-snap track, autoplay, progress bars. Horizontal scroll only, so no page-scroll listeners */
(function(){
  function setup(root){
    (root||document).querySelectorAll('[data-bb-car]').forEach(function(c){
      if(c.dataset.ready)return;c.dataset.ready=1;
      var track=c.querySelector('[data-track]'),slides=[].slice.call(c.querySelectorAll('[data-slide]')),bars=[].slice.call(c.querySelectorAll('.bb-car__bar'));
      var n=slides.length,cur=0,timer=null,ms=parseInt(c.dataset.interval,10)||6000;
      var auto=c.dataset.autoplay!=='false'&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      c.style.setProperty('--bb-int',ms+'ms');
      function mark(i){
        cur=i;
        slides.forEach(function(s,k){s.classList.toggle('is-active',k===i);s.setAttribute('aria-hidden',k===i?'false':'true')});
        bars.forEach(function(b,k){b.classList.remove('is-active','is-done');void b.offsetWidth;if(k<i)b.classList.add('is-done');if(k===i)b.classList.add('is-active')});
      }
      function go(i,smooth){i=(i+n)%n;track.scrollTo({left:i*track.clientWidth,behavior:smooth===false?'auto':'smooth'});mark(i);restart()}
      function restart(){clearTimeout(timer);if(auto&&!c.classList.contains('is-paused'))timer=setTimeout(function(){go(cur+1)},ms)}
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting&&e.intersectionRatio>.6){var i=slides.indexOf(e.target);if(i!==cur){mark(i);restart()}}})},{root:track,threshold:[.6]});
      slides.forEach(function(s){io.observe(s)});
      bars.forEach(function(b,k){b.addEventListener('click',function(){go(k)})});
      var p=c.querySelector('[data-prev]'),nx=c.querySelector('[data-next]');
      p&&p.addEventListener('click',function(){go(cur-1)});nx&&nx.addEventListener('click',function(){go(cur+1)});
      track.addEventListener('keydown',function(e){if(e.key==='ArrowRight')go(cur+1);if(e.key==='ArrowLeft')go(cur-1)});
      function pause(){c.classList.add('is-paused');clearTimeout(timer)}
      function resume(){c.classList.remove('is-paused');restart()}
      c.addEventListener('mouseenter',pause);c.addEventListener('mouseleave',resume);
      c.addEventListener('focusin',pause);c.addEventListener('focusout',resume);
      track.addEventListener('touchstart',pause,{passive:true});track.addEventListener('touchend',function(){setTimeout(resume,1500)},{passive:true});
      document.addEventListener('visibilitychange',function(){document.hidden?pause():resume()});
      window.addEventListener('resize',function(){track.scrollTo({left:cur*track.clientWidth,behavior:'auto'})});
      mark(0);restart();
    });
  }
  document.addEventListener('DOMContentLoaded',function(){setup()});
  document.addEventListener('shopify:section:load',function(e){setup(e.target)});
})();
